import useClientMutation from '../../common/useClientMutation';
import { USER_REGISTRATION_ENCODED } from '../../consts';
export default function useRegistration(props) {
    return useClientMutation({
        cacheKey: 'userRegistration',
        url: USER_REGISTRATION_ENCODED,
        fetchOptions: {
            method: 'POST',
            headers: {
                accept: 'application/json',
                'content-type': 'application/x-www-form-urlencoded'
            }
        },
        clientOptions: {
            throwOnError: false,
            retry: false,
            gcTime: 0,
            onSuccess: props?.onSuccess,
            onError: props?.onError
        },
        transformResponse: (result)=>{
            return {
                ...result,
                status: result['login-status'],
                success: result.success === true || result.success === 'true',
                ...Array.isArray(result.message) ? {
                    message: undefined,
                    messages: result.message
                } : typeof result.message === 'string' ? {
                    message: undefined,
                    messages: [
                        result.message
                    ]
                } : {}
            };
        }
    });
}

//# sourceMappingURL=useRegistration.js.map